import { gql } from "@apollo/client";

const schema = {
  get: {
    name: "city",
    serviceName: "graphql",
    query: gql`
      query city($ids: [String]) {
        city(ids: $ids) {
          data {
            id
            title
          }
        }
      }
    `,
  },
};

export default schema;
